/* global $:true */
import debug from "debug";

import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/remove-spaces';
const log = debug(MODULE_NAME);
const ELEMENT_SELECTOR = '[data-remove-spaces]';


class RemoveSpacesPlugin {

	constructor (element) {
		this.element = element;
		this.$element = $(element);
		log('RemoveSpacesPlugin', element);
		this.watch();
	}

	watch () {
		this.$element.on('change', this.removeSpaces.bind(this));
	}

	removeSpaces () {
		var val = this.$element.val();
		val = val.replace(/\s/g, "");
		this.$element.val(val);
	}

}

plugin('removeSpaces', RemoveSpacesPlugin);

export function exec () {
	$(document).ready(() => {
		log('binding');
		$(ELEMENT_SELECTOR).removeSpaces();
		log('bound');
	});
}





// WEBPACK FOOTER //
// ./client/src/core/modules/remove-spaces/index.js